import { render, staticRenderFns } from "./ResultItemBrowse.vue?vue&type=template&id=4a8a49b3"
import script from "./ResultItemBrowse.vue?vue&type=script&lang=js"
export * from "./ResultItemBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports